var map = {
	"./bet.png": 9062,
	"./bet_h.png": 9258,
	"./dl.png": 6127,
	"./dl_h.png": 5332,
	"./hd.png": 8899,
	"./hd_h.png": 6783,
	"./home.png": 3027,
	"./home_h.png": 610,
	"./jinbi.png": 4665,
	"./jinbi_h.png": 2963,
	"./jy.png": 3413,
	"./jy_h.png": 3761,
	"./recharge.png": 9606,
	"./recharge_h.png": 1730,
	"./tx.png": 3927,
	"./tx_h.png": 2231,
	"./znx.png": 2465,
	"./znx_h.png": 8820,
	"./zuanshi.png": 7725,
	"./zuanshi_h.png": 8046
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1764;